import { Box, Typography, CircularProgress, Alert } from '@mui/material';
import OrganizationsTable from '../../../components/organisations/OrganisationsTable';
import { useOrganizations } from '../../../hooks/organisation/useOrganizations';
import { Organisation } from '../../../types/organization';

interface OrganizationListProps {
  onEdit: (org: Organisation) => void;
  onDelete: (id: string) => void;
  onSelect: (org: Organisation) => void;
}

export default function OrganizationList({ onEdit, onDelete, onSelect }: OrganizationListProps) {
  const { organizations, isLoading, error } = useOrganizations();

  const activeOrganizations = organizations.filter(org => org.status === 'active');

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  if (!organizations.length) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography color="text.secondary">No organizations found</Typography>
      </Box>
    );
  }

  return (
    <OrganizationsTable
      organizations={activeOrganizations}
      onEdit={onEdit}
      onDelete={onDelete}
      onSelect={onSelect}
    />
  );
}
